export default "__VITE_ASSET__C340FkvO__"